import React from 'react';

const GoogleAuthButton = ({ handleClick }) => (
  <button type="button" className="auth-btn google" onClick={handleClick}>
    Sign in with Google
  </button>
);

export default GoogleAuthButton;
